// extracted by mini-css-extract-plugin
module.exports = {"container":"_header404_container__Oqx_0","bubble":"_header404_bubble__rjBew","extra":"_header404_extra__LiVDS"};